export const marketingUrl: string = "https://www.mollie.com/products/invoicing";
export const molliePlatformApiUrl: string = import.meta.env
  .VITE_MOLLIE_PLATFORM_SUPPLIERS_API_URL;
